const register = [
  {
    text: 'product.product_product-number',
    value: 'productNumber',
    sortable: false,
    width: '9%'
  },
  {
    text: 'sale.sale_product-name-capacity',
    value: 'productInfoAndCapacity',
    sortable: false,
    width: '25%'
  },
  {
    text: 'common.product_consumption-tax-rate',
    value: 'taxId',
    sortable: false,
    width: '5%',
    align: 'center'
  },
  {
    text: 'order.order_reference-price',
    value: 'purchasePrice',
    sortable: false,
    width: '8%',
    align: 'center',
    unit: '%',
    currencyIdName: 'purchasePriceCurrencyId'
  },
  {
    text: '仕入価格\n（unitName）',
    value: 'purchasePriceAndUnitName',
    sortable: false,
    width: '10%',
    align: 'center'
  },
  {
    text: '在庫\n（移動中在庫）',
    value: 'stock',
    sortable: false,
    width: '10%',
    align: 'center'
  },
  {
    text: 'common.input_order-quantity',
    value: 'count',
    sortable: false,
    width: '8%'
  },
  {
    text: 'sale.sale_price',
    value: 'amount',
    sortable: false,
    width: '10%',
    align: 'center',
    unit: '円'
  }
]
const history = [
  {
    text: 'order.order_invalid',
    value: 'invalid',
    sortable: false,
    width: '5%'
  },
  {
    text: 'product.product_product-number',
    value: 'productNumber',
    sortable: false,
    width: '9%'
  },
  {
    text: 'sale.sale_product-name-capacity',
    value: 'productInfoAndCapacity',
    sortable: false,
    width: '25%'
  },
  {
    text: 'common.product_consumption-tax-rate',
    value: 'taxId',
    sortable: false,
    width: '5%',
    align: 'center'
  },
  {
    text: 'order.order_reference-price',
    value: 'purchasePrice',
    sortable: false,
    width: '8%',
    align: 'center',
    unit: '%',
    currencyIdName: 'purchasePriceCurrencyId'
  },
  {
    text: '仕入価格\n（unitName）',
    value: 'purchasePriceAndUnitName',
    sortable: false,
    width: '8%',
    align: 'center'
  },
  {
    text: '在庫\n（移動中在庫）',
    value: 'stock',
    sortable: false,
    width: '10%',
    align: 'center'
  },
  {
    text: 'common.input_order-quantity',
    value: 'count',
    sortable: false,
    width: '10%'
  },
  {
    text: 'sale.sale_price',
    value: 'amount',
    sortable: false,
    width: '10%',
    align: 'center',
    unit: '円'
  }
]

export default { register, history }
